<template>
    <div>
        <breadcrumb :routerList="[{to:'/invoice/reformCatalogList',title:'改制目录'},{title:'修改改制目录'}]"/>
        <div class="h-content">
            <div class="h-rowBox">
                <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                         class="demo-ruleForm h-formbLine h-formbLine1">
                    <div class="h-rowCon">

                        <div class="h-pieceIn2">
                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                <h1>修改改制目录</h1>
                            </div>
                            <div class="h-pieceCon2">
                                <div class="h-formLine Yangbiao">
                                    <el-form-item label="改制目录名称" class="h-elformWrap-2" required>
                                        <el-input placeholder="请输入" v-model="saveData.specificDivision"></el-input>
                                    </el-form-item>
                                    <el-form-item label="改制要求" class="h-elformWrap-2" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                                        <el-input placeholder="请输入" v-model="saveData.specificReform"></el-input>
                                    </el-form-item>
                                    <el-form-item  label="产品大类编码" class="h-elformWrap-2" label-width="100" prop="oneLId" :rules="[{ required: true, message: '请选择产品大类', trigger: 'blur'},]">
                                        <el-select value-key="id" filterable  v-model="saveData.oneLId" placeholder="请选择" @change="getOneLName">
                                            <el-option v-for="item in allOne" :key="item.oneLId"  :label="`[${item.oneLId}] ${item.oneLName}`" :value="item.oneLId"  >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="产品大类名称" class="h-elformWrap-2" required>
                                        <el-input placeholder="选择产品大类编码自动带出" v-model="saveData.oneLName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="链群" class="h-elformWrap-2" :rules="[{ required: true, message: '请选择链群', trigger: 'blur'},]">
                                        <el-select v-model="saveData.lianqunCode" placeholder="请选择" @change="getLianqunName">
                                            <el-option v-for="item in allLianqun" :key="item.lianqunCode" :label="item.lianqunName" :value="item.lianqunCode">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="改制类型" class="h-elformWrap-2" required>
                                        <el-select v-model="saveData.specificType" placeholder="请选择" :clearable="true">
                                            <el-option value="1" label="内销"></el-option>
                                            <el-option value="2" label="外销"></el-option>
                                            <el-option value="3" label="内外销通用"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="单台加价" class="h-elformWrap-2" :rules="[{ required: true, message: '必须输入单台加价', trigger: 'blur'},]">
                                        <el-input placeholder="请输入" v-model.number="saveData.reformPrice"></el-input>
                                    </el-form-item>
                                    <el-form-item label="备注" class="h-elformWrap-2">
                                        <el-input v-model="saveData.remark"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgwhite" @click="submitFlage('暂存')" v-if="this.saveData.instid === ''">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitFlage('提交')">确认提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import _ from "loadsh";
    import reduceCost from "@/api/invoice/reduceCost";
    import specificCatalogue from "@/api/reform/specificCatalogue";
    export default {
        data() {
            return {
                instid: '',
                saveData:{
                    id:'',
                    instid: '',
                    lianqunCode:'',
                    lianqunName:'',
                    oneLId:'',
                    oneLName:'',
                    specificDivision:'',
                    specificReform:'',
                    reformPrice:0,
                    remark:'',
                    specificType:'',
                },
                f: {
                    productModel: '',
                    productCode: ''
                },
                rules:{},
                //存放所有大类，新增改制条目时用
                allOne:[],
                //存放所有链群，新增改制条目时用
                allLianqun:[],
            }
        },
        created() {
            this.createSpecific();
            this.getReformCatalogDetail(this.$route.query.reformCatalogId)
        },
        // 添加路由监听
        watch: {
            '$route'(to, from) {
                if (to.name === from.name && to.query.reformCatalogId !== from.query.reformCatalogId) {
                    // 相同路由但不同ID时重新加载数据
                    this.getReformCatalogDetail(to.query.reformCatalogId)
                }
            }
        },
        methods:{
            submitFlage(data){
                if (this.saveData.specificDivision === '') {
                    return this.$msg.msge("改制目录名称不能为空!");
                }
                if (this.saveData.specificReform === '') {
                    return this.$msg.msge("改制要求不能为空!");
                }
                if (this.saveData.reformPrice === '' || this.saveData.reformPrice === undefined) {
                    return this.$msg.msge("单台加价不能为空!");
                }
                if (this.saveData.specificType === '') {
                    return this.$msg.msge("改制类型不能为空!");
                }
                if (this.saveData.lianqunCode === '') {
                    return this.$msg.msge("链群不能为空!");
                }
                if (this.saveData.oneLId === '') {
                    return this.$msg.msge("产品大类不能为空!");
                }
                if(data === '提交'){
                    this.subTo();
                }else {
                    this.saveTo();
                }
            },
            saveTo() {
                reduceCost.insertReformCatalog(this.saveData).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    reduceCost.submitNew(this.saveData).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.submitData = [];
                        this.$router.push({path: "/invoice/reformCatalogList"});
                    })
                })
            },
            getReformCatalogDetail(id) {
                reduceCost.getReformCatalogDetail({id: id}).then(rd => {
                    if (rd.obj !== null) {
                        this.saveData = rd.obj;
                        if (this.saveData.oneLId !== undefined && this.saveData.oneLId !== '') {
                            this.selectAllDivision(this.saveData.oneLId);
                        }
                    }
                })
            },
            createSpecific() {
                this.createSpecificFlag = true;
                //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            },
            getOneLName(q){
                //获取name
                const one = _.find(this.allOne,{oneLId:q})

                this.saveData.oneLName = one.oneLName;
                this.selectAllDivision(q);
            },
            selectAllDivision(oneLId){
                //查询所有改制目录
                specificCatalogue.selectAllDivision({oneLId: oneLId}).then(rd => {
                    //过滤出所有可选链群
                    this.allLianqun = [];
                    for (let item of rd) {
                        if (this.allLianqun.findIndex(item => item.lianqunCode=== item.lianqunCode) === -1) {
                            this.allLianqun.push(item);
                        }
                    }

                })
            },
            getLianqunName(q){
                //获取name
                const lianqun = _.find(this.allLianqun,{lianqunCode:q})

                this.saveData.lianqunName = lianqun.lianqunName;
            },
            //返回
            backS() {
                this.$router.push({path: "/invoice/reformCatalogList"});
            },
        },
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 45% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 86%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
